<ng-container *ngIf="{
    minimalOrderPrice: (minimalOrderPrice$ | async) || 0,
    totalPrice: (totalPrice$ | async) || 0,
    actualCostRule: actualCostRule$ | async,
    nextDeliveryLimit: (nextDeliveryLimit$ | async) || 0,
    nextActualCostRule: nextActualCostRule$ | async,
    currency: currency$ | async,
    locale: locale$ | async,
  } as data"
>
  <div class="product-mini _center" *ngIf="data.actualCostRule">
    <div class="product-mini__photo _sm">
      <div class="product-mini__img"><i class="icomoon icomoon--courier"></i></div>
    </div>
    <div class="product-mini__body">
      <div class="product-mini__title h3">
        <ng-container *ngIf="data.actualCostRule && data.actualCostRule.cost === 0">
          {{ freePriceDeliveryMessage }}
        </ng-container>
        <ng-container *ngIf="data.minimalOrderPrice <= data.totalPrice && data.actualCostRule && data.actualCostRule.cost">
          <span i18n="@@Delivery">Delivery</span>&nbsp;
          <app-price [price]="data.actualCostRule.cost"></app-price>
        </ng-container>
      </div>

      <ng-container *ngIf="(isBasketProcessing$ | async)?.value !== 'pending'; else textLoader">
        <div class="product-mini__caption small">
          <ng-container *ngIf="data.minimalOrderPrice > data.totalPrice">
            {{ minimalPriceDeliveryMessage
            .replace('%minimalPrice%', (data.minimalOrderPrice - data.totalPrice) | priceCurrency : data.currency : data.locale)
            }}
          </ng-container>

          <ng-container *ngIf="data.minimalOrderPrice <= data.totalPrice && data.actualCostRule && data.nextActualCostRule">
            <ng-container *ngIf="data.nextActualCostRule.cost">
              {{ intervalPriceDeliveryMessage
              .replace('%deliveryPrice%', data.actualCostRule.cost | priceCurrency : data.currency : data.locale)
              .replace('%nextDeliveryPrice%', data.nextActualCostRule.cost | priceCurrency : data.currency : data.locale)
              .replace('%needPrice%', data.nextDeliveryLimit | priceCurrency : data.currency : data.locale)
              }}
            </ng-container>

            <ng-container *ngIf="data.nextActualCostRule.cost === 0">
              {{ intervalFreeDeliveryMessage
              .replace('%deliveryPrice%', data.actualCostRule.cost | priceCurrency : data.currency : data.locale)
              .replace('%needPrice%', data.nextDeliveryLimit | priceCurrency : data.currency : data.locale)
              }}
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>


<ng-template #textLoader>
  <mat-spinner color="accent" [diameter]="15"></mat-spinner>
</ng-template>
